/**
 * Created by Jasmine on 2018/8/9.
 */

import { observable } from "mobx";
import { request, apis } from '../../../utils/net';
import moment from 'moment'

const store = observable({
    // 查询form
    searchForm: {
        begin_at: moment().startOf('month').unix(),         //起始时间戳
        end_at: moment().unix(),           //终止时间戳
        buyer_title: '',
        invoice_type: '',       //发票类型 0|蓝票 1|红票
        tax_rate: '',           //销方信息:税率
        ticket_sn: '',          //发票号码
        ticket_code: '',        //发票代码
        store_id: '',           //门店id
        user_id: '',            //子账号的用户id
        status: '',             //发票状态
        source: '',             //开票方式
        invoice_style: '', // 发票类型
    },

    // 开票状态, 3|开票失败，4|取消订单，5|等待订单, 6|订单异常，7|打印失败
    statusList: [
        // {id: 0, name: '待审核'},
        { id: 1, name: '开票中' },
        { id: 2, name: '开票成功' },
        { id: 3, name: '开票失败' },
        { id: 7, name: '打印失败' },
        { id: 8, name: '已作废' }
    ],

    // 门店列表
    storeMap: {},
    storeList: [],

    // 针对海鼎，提供等待订单，订单异常两种状态
    setHaidingStatus() {
        this.statusList = [
            ...this.statusList,
            { id: 5, name: '等待订单' },
            { id: 6, name: '订单异常' }
        ]
    },

    invoiceTypes: [], // 发票类型

    specialInvoiceType: false,//是否是成品油

    unit_price: 0,//单价价格

    // taxDiscList: [],   //税盘号列表

    selectedRows: {
        keys: [],
        records: []
    }, // 选中的开票行数据

    // 获取记录列表
    getListRecord(params, page_size = 10) {
        request({
            url: apis.postListRecord,
            method: 'POST',
            data: { ...params, page_size }
        })
    },

    getStoreList() {
        // 获取商户的门店列表,子账号列表
        return request({
            url: apis.getStores
        }).then(res => {
            const { store_list = [] } = res
            const storeMap = {}
            store_list.forEach(item => { storeMap[item.id] = item.name })
            this.storeMap = storeMap
            this.storeList = store_list
            return res
        });
    },

    // 批量重试蓝票
    batchBlueRetry(arr) {
        return request({
            url: apis.invoiceRetry,
            method: 'post',
            data: {
                order_list: JSON.stringify(arr)
            }
        })
    },

    // 海鼎批量重试蓝票
    batchRetryHaiding(params) {
        return request({
            url: apis.haidingInvoiceRetry,
            method: 'post',
            data: {
                order_sn: params
            }
        })
    },

    // 批量重试红票
    batchRedRetry(arr) {
        return request({
            url: apis.postRedRecord,
            method: 'post',
            data: {
                order_sn: arr
            }
        })
    },

    blueRetry(orderSN) {
        return request({
            url: apis.postBlueRetryOne,
            method: 'post',
            data: {
                order_sn: orderSN
            }
        })
    },

    redRetry(orderSN) {
        return this.batchRedRetry(orderSN)
    },

    haidingRetry(orderSN) {
        return this.batchRetryHaiding(orderSN)
    },

    // 成都点下户刷新开票状态
    dxhRefreshInvoiceStatus(orderSN) {
        return request({
            url: apis.getChengduDxhRefresh,
            data: {
                orderSn: orderSN
            }
        })
    },

    // 获取商户可开具发票类型列表
    getInvoiceTypes(order) {
        return request({
            url: apis.getInvoiceTypes,
            method: 'post',
            data: { order_sn: order || ''}
        }).then(res => {
            this.invoiceTypes = res
        })
    },

    sendPdf(orderSN, email) {
        return request({
            url: apis.sendPdf,
            method: 'post',
            data: {
                order_sn: orderSN,
                email
            }
        })
    },

    /**
     * 作废
     * @param orderSn
     * @return {*}
     */
    invoiceInvalid(orderSn, remark) {
        return request({
            url: apis.invoiceInvalid,
            method: 'post',
            data: {
                order_sn: orderSn,
                remark
            }
        })
    }
})

export default store;
